/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AccountTypeEnum {
  None = "None",
  Admin = "Admin",
  Manager = "Manager",
  Worker = "Worker",
  Volunteer = "Volunteer",
}

export enum ActivityTypeEnum {
  Record = "Record",
  Comment = "Comment",
  Evaluation = "Evaluation",
}

export interface AdminUserModel {
  userTenants?: TenantUserBasicModel[] | null;
  email?: string | null;
  language?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AdminUserModelApiResultSuccess {
  returnValue?: AdminUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AdminUserModelIEnumerableApiResultSuccess {
  returnValue?: AdminUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum AggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
}

export interface AggregationModel {
  predicates?: PredicateDefinition[] | null;
  aggregation?: AggregationEnum;
  aggregationProperty?: string | null;
}

export interface AggregationResponse {
  result?: IActionResult;
}

export interface AggregationResponseApiResultSuccess {
  returnValue?: AggregationResponse;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultBase {
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultException {
  message?: string | null;
  stackTrace?: string | null;
  error?: ApiResultException;
}

export interface ApiResultFailed {
  returnValue?: Null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApplicationUserModel {
  language?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  twoFactorEnabled?: boolean;
  systemUser?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  avatar?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ApplicationUserModelApiResultSuccess {
  returnValue?: ApplicationUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AvatarUploadModel {
  contentType?: string | null;
  base64?: string | null;
}

export interface AvatarUploadModelApiResultSuccess {
  returnValue?: AvatarUploadModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface BillingModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;
  isLocked?: boolean;
  billingIsSentToClient?: boolean;
  receiptIsSentToClient?: boolean;

  /** @format date-time */
  billingSentOn?: string | null;

  /** @format date-time */
  receiptSentOn?: string | null;

  /** @format double */
  totalAmount?: number | null;
  isPaid?: boolean | null;

  /** @format double */
  paidAmount?: number | null;

  /** @format date-time */
  printedOn?: string | null;
  isLoweredUnitPrice?: boolean | null;
  transactionEmails?: TransactionEmailModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface BillingModelApiResultSuccess {
  returnValue?: BillingModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface BillingModelIEnumerableApiResultSuccess {
  returnValue?: BillingModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum BillingTypeEnum {
  Charged = "Charged",
  Free = "Free",
}

export interface CareAllowenceModel {
  name?: string | null;

  /** @format double */
  allowenceValue?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CareAllowenceModelApiResultSuccess {
  returnValue?: CareAllowenceModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CareAllowenceModelIEnumerableApiResultSuccess {
  returnValue?: CareAllowenceModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CatalogueItemBasicModel {
  type?: BillingTypeEnum;
  catalogueItemType?: CatalogueItemTypeEnum;
  name?: string | null;
  description?: string | null;

  /** @format uuid */
  unitOfMeasureId?: string;
  unitOfMeasure?: UnitOfMeasureModel;

  /** @format double */
  unitPrice?: number;

  /** @format uuid */
  reportedUnitOfMeasureId?: string;
  reportedUnitOfMeasure?: UnitOfMeasureModel;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CatalogueItemModel {
  type?: BillingTypeEnum;
  catalogueItemType?: CatalogueItemTypeEnum;
  name?: string | null;
  description?: string | null;

  /** @format uuid */
  unitOfMeasureId?: string;
  unitOfMeasure?: UnitOfMeasureModel;

  /** @format double */
  unitPrice?: number;

  /** @format uuid */
  reportedUnitOfMeasureId?: string;
  reportedUnitOfMeasure?: UnitOfMeasureModel;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CatalogueItemModelApiResultSuccess {
  returnValue?: CatalogueItemModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CatalogueItemModelIEnumerableApiResultSuccess {
  returnValue?: CatalogueItemModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum CatalogueItemTypeEnum {
  Ordinary = "Ordinary",
  Facultative = "Facultative",
  Lunch = "Lunch",
}

export interface ClosingModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  date?: string;

  /** @format double */
  price?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ClosingModelPagedResult {
  queryable?: ClosingModel[] | null;

  /** @format int32 */
  currentPage?: number;

  /** @format int32 */
  pageCount?: number;

  /** @format int32 */
  pageSize?: number;

  /** @format int32 */
  rowCount?: number;
}

export interface ClosingModelPagedResultApiResultSuccess {
  returnValue?: ClosingModelPagedResult;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CodebookBasicModel {
  type?: CodebookTypeEnum;
  name?: string | null;
  nameIdentifier?: string | null;

  /** @format int32 */
  position?: number;
  color?: string | null;
  defaultValue?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CodebookModel {
  type?: CodebookTypeEnum;
  name?: string | null;
  nameIdentifier?: string | null;

  /** @format int32 */
  position?: number;
  color?: string | null;
  defaultValue?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CodebookModelApiResultSuccess {
  returnValue?: CodebookModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CodebookModelIEnumerableApiResultSuccess {
  returnValue?: CodebookModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum CodebookTypeEnum {
  PartyState = "PartyState",
  WorkTaskState = "WorkTaskState",
  MaritalStatus = "MaritalStatus",
  LegalCapacity = "LegalCapacity",
  LevelOfDisability = "LevelOfDisability",
  PaymentMethod = "PaymentMethod",
}

export enum ConditionalQueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
}

export interface ConfirmEmailModel {
  /** @format email */
  email: string;
  token?: string | null;
}

export interface ConfirmResetPasswordModel {
  /** @format email */
  email: string;
  token?: string | null;

  /** @format password */
  password: string;
}

export enum ConvertFunctionEnum {
  None = "none",
  Date = "date",
  Day = "day",
  Month = "month",
  Year = "year",
  Hour = "hour",
  Minute = "minute",
  Second = "second",
}

export interface DistrictModel {
  name?: string | null;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface DistrictModelApiResultSuccess {
  returnValue?: DistrictModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface DistrictModelIEnumerableApiResultSuccess {
  returnValue?: DistrictModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ExportQueryModel {
  fileName?: string | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export interface FileDownloadModel {
  filename?: string | null;
  contentType?: string | null;
  base64?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FileDownloadModelApiResultSuccess {
  returnValue?: FileDownloadModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileModel {
  /** @format uuid */
  ownerId?: string | null;
  owner?: PartyBasicModel;

  /** @format uuid */
  folderId?: string | null;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBasicModel;
  description?: string | null;
  fileName?: string | null;

  /** @format int64 */
  fileSize?: number;
  contentType?: string | null;
  blobName?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FileModelApiResultSuccess {
  returnValue?: FileModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileModelIEnumerableApiResultSuccess {
  returnValue?: FileModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FolderBaseModel {
  name?: string | null;
  entityType?: FolderEntityTypeEnum;

  /** @format uuid */
  entityId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum FolderEntityTypeEnum {
  Root = "Root",
  Party = "Party",
  General = "General",
}

export interface FolderModel {
  /** @format uuid */
  parentId?: string | null;
  parent?: FolderBaseModel;
  children?: FolderBaseModel[] | null;
  name?: string | null;
  entityType?: FolderEntityTypeEnum;

  /** @format uuid */
  entityId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FolderModelApiResultSuccess {
  returnValue?: FolderModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FolderModelIEnumerableApiResultSuccess {
  returnValue?: FolderModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum FrequencyEnum {
  Regular = "Regular",
  OneTime = "OneTime",
}

export interface GroupByAdditionDefinition {
  keyField?: string | null;
  additionType?: GrouppedAdditionEnum;
  outputName?: string | null;
}

export interface GroupByDefinition {
  field?: string | null;
  convert?: ConvertFunctionEnum;
}

export interface GroupByProjectionDefinition {
  field?: string | null;
  aggregation?: ProjectionAggregationEnum;
  outputField?: string | null;
  conditional?: boolean;
  op?: ConditionalQueryOperator;
  comparand?: any;
}

export enum GrouppedAdditionEnum {
  Party = "Party",
  PartyBasic = "PartyBasic",
}

export interface GrouppedQueryModel {
  groupby?: GroupByDefinition[] | null;
  projections?: GroupByProjectionDefinition[] | null;
  additions?: GroupByAdditionDefinition[] | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum HttpStatusCode {
  Continue = "Continue",
  SwitchingProtocols = "SwitchingProtocols",
  Processing = "Processing",
  EarlyHints = "EarlyHints",
  OK = "OK",
  Created = "Created",
  Accepted = "Accepted",
  NonAuthoritativeInformation = "NonAuthoritativeInformation",
  NoContent = "NoContent",
  ResetContent = "ResetContent",
  PartialContent = "PartialContent",
  MultiStatus = "MultiStatus",
  AlreadyReported = "AlreadyReported",
  IMUsed = "IMUsed",
  Ambiguous = "Ambiguous",
  Moved = "Moved",
  Redirect = "Redirect",
  RedirectMethod = "RedirectMethod",
  NotModified = "NotModified",
  UseProxy = "UseProxy",
  Unused = "Unused",
  TemporaryRedirect = "TemporaryRedirect",
  PermanentRedirect = "PermanentRedirect",
  BadRequest = "BadRequest",
  Unauthorized = "Unauthorized",
  PaymentRequired = "PaymentRequired",
  Forbidden = "Forbidden",
  NotFound = "NotFound",
  MethodNotAllowed = "MethodNotAllowed",
  NotAcceptable = "NotAcceptable",
  ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
  RequestTimeout = "RequestTimeout",
  Conflict = "Conflict",
  Gone = "Gone",
  LengthRequired = "LengthRequired",
  PreconditionFailed = "PreconditionFailed",
  RequestEntityTooLarge = "RequestEntityTooLarge",
  RequestUriTooLong = "RequestUriTooLong",
  UnsupportedMediaType = "UnsupportedMediaType",
  RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
  ExpectationFailed = "ExpectationFailed",
  MisdirectedRequest = "MisdirectedRequest",
  UnprocessableEntity = "UnprocessableEntity",
  Locked = "Locked",
  FailedDependency = "FailedDependency",
  UpgradeRequired = "UpgradeRequired",
  PreconditionRequired = "PreconditionRequired",
  TooManyRequests = "TooManyRequests",
  RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
  UnavailableForLegalReasons = "UnavailableForLegalReasons",
  InternalServerError = "InternalServerError",
  NotImplemented = "NotImplemented",
  BadGateway = "BadGateway",
  ServiceUnavailable = "ServiceUnavailable",
  GatewayTimeout = "GatewayTimeout",
  HttpVersionNotSupported = "HttpVersionNotSupported",
  VariantAlsoNegotiates = "VariantAlsoNegotiates",
  InsufficientStorage = "InsufficientStorage",
  LoopDetected = "LoopDetected",
  NotExtended = "NotExtended",
  NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export type IActionResult = object;

export interface IdentityError {
  code?: string | null;
  description?: string | null;
}

export interface IdentityResult {
  succeeded?: boolean;
  errors?: IdentityError[] | null;
}

export enum JunctionOperator {
  And = "and",
  Or = "or",
}

export interface NeedModel {
  name?: string | null;

  /** @format int32 */
  position?: number;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface NeedModelApiResultSuccess {
  returnValue?: NeedModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface NeedModelIEnumerableApiResultSuccess {
  returnValue?: NeedModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export type Null = object;

export interface ObjectIEnumerableApiResultSuccess {
  returnValue?: any[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface Operation {
  value?: any;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export enum OpResultStatus {
  None = "none",
  Succeeded = "succeeded",
  Canceled = "canceled",
  Faulted = "faulted",
}

export interface OrderByDefinition {
  field?: string | null;

  /** @format int32 */
  index?: number | null;
  order?: SortOrder;
}

export interface PartyActivityModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;
  createdBy?: UserBaseModel;
  description?: string | null;
  type?: ActivityTypeEnum;

  /** @format uuid */
  tenantUserId?: string | null;
  tenantUser?: TenantUserBasicModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyActivityModelApiResultSuccess {
  returnValue?: PartyActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyActivityModelIEnumerableApiResultSuccess {
  returnValue?: PartyActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyBasicModel {
  /** @format int32 */
  generatedId?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  personalNumber?: string | null;
  address?: string | null;
  street?: string | null;
  city?: string | null;
  zip?: string | null;

  /** @format uuid */
  districtId?: string | null;
  district?: DistrictModel;

  /** @format uuid */
  townId?: string | null;
  town?: TownModel;

  /** @format uuid */
  mainCareProviderId?: string | null;
  mainCareProvider?: UserBaseModel;
  phoneNumber?: string | null;
  email?: string | null;

  /** @format date-time */
  birthDate?: string | null;

  /** @format uuid */
  clientStateId?: string;
  clientState?: CodebookModel;
  externalSystemId?: string | null;

  /** @format uuid */
  paymentMethodId?: string | null;
  paymentMethod?: CodebookModel;

  /** @format date-time */
  nextNeedEvaluationDate?: string | null;

  /** @format date-time */
  nextWorkTaskEvaluationDate?: string | null;
  partyCareProviders?: PartyCareProviderModel[] | null;

  /** @format date-time */
  activatedOn?: string | null;

  /** @format date-time */
  archivedOn?: string | null;
  benefitClaim?: boolean | null;

  /** @format uuid */
  terminationReasonId?: string | null;
  terminationReason?: TerminationReasonModel;

  /** @format uuid */
  careAllowenceId?: string | null;
  careAllowence?: CareAllowenceModel;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyBasicModelIEnumerableApiResultSuccess {
  returnValue?: PartyBasicModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyCareProviderModel {
  /** @format uuid */
  partyId?: string;

  /** @format uuid */
  userId?: string;
  user?: UserBaseModel;
  canProvideChargedTasks?: boolean;
  canProvideFreeTasks?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyCareProviderModelApiResultSuccess {
  returnValue?: PartyCareProviderModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyCareProviderModelIEnumerableApiResultSuccess {
  returnValue?: PartyCareProviderModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyContactModel {
  /** @format uuid */
  partyId?: string;
  firstName?: string | null;
  lastName?: string | null;
  relationship?: string | null;
  phoneNumber?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyContactModelApiResultSuccess {
  returnValue?: PartyContactModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyContactModelIEnumerableApiResultSuccess {
  returnValue?: PartyContactModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyExportModel {
  exportType?: PartyExportTypeEnum;
  fileName?: string | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum PartyExportTypeEnum {
  Parties = "Parties",
  ClientEvaluations = "ClientEvaluations",
}

export interface PartyModel {
  floorNumber?: string | null;
  description?: string | null;
  reason?: string | null;
  entrustedKeys?: boolean | null;
  activeContract?: boolean | null;
  howLearnedAboutUs?: string | null;
  conditionBeforeStart?: string | null;
  accountNumber?: string | null;
  secondAccountNumber?: string | null;
  paymentVariableSymbol?: string | null;

  /** @format uuid */
  maritalStatusId?: string | null;
  maritalStatus?: CodebookModel;

  /** @format uuid */
  legalCapacityId?: string | null;
  legalCapacity?: CodebookModel;

  /** @format uuid */
  levelOfDisabilityId?: string | null;
  levelOfDisability?: CodebookModel;
  doctorName?: string | null;
  doctorPhoneNumber?: string | null;
  hospitalName?: string | null;
  hospitalAddress?: string | null;
  medicalProblems?: string | null;
  medicalRestrictions?: string | null;
  incontinence?: string | null;
  otherMedicalInformation?: string | null;
  insideMobility?: string | null;
  outsideMobility?: string | null;

  /** @format date-time */
  acquisitionDate?: string | null;
  interestDescription?: string | null;
  risk?: string | null;
  sex?: SexEnum;
  partyContacts?: PartyContactModel[] | null;

  /** @format int32 */
  generatedId?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  personalNumber?: string | null;
  address?: string | null;
  street?: string | null;
  city?: string | null;
  zip?: string | null;

  /** @format uuid */
  districtId?: string | null;
  district?: DistrictModel;

  /** @format uuid */
  townId?: string | null;
  town?: TownModel;

  /** @format uuid */
  mainCareProviderId?: string | null;
  mainCareProvider?: UserBaseModel;
  phoneNumber?: string | null;
  email?: string | null;

  /** @format date-time */
  birthDate?: string | null;

  /** @format uuid */
  clientStateId?: string;
  clientState?: CodebookModel;
  externalSystemId?: string | null;

  /** @format uuid */
  paymentMethodId?: string | null;
  paymentMethod?: CodebookModel;

  /** @format date-time */
  nextNeedEvaluationDate?: string | null;

  /** @format date-time */
  nextWorkTaskEvaluationDate?: string | null;
  partyCareProviders?: PartyCareProviderModel[] | null;

  /** @format date-time */
  activatedOn?: string | null;

  /** @format date-time */
  archivedOn?: string | null;
  benefitClaim?: boolean | null;

  /** @format uuid */
  terminationReasonId?: string | null;
  terminationReason?: TerminationReasonModel;

  /** @format uuid */
  careAllowenceId?: string | null;
  careAllowence?: CareAllowenceModel;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyModelApiResultSuccess {
  returnValue?: PartyModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyModelIEnumerableApiResultSuccess {
  returnValue?: PartyModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyNeedGroupModel {
  partyNeeds?: PartyNeedModel[] | null;
  createdBy?: UserBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  tenantUserId?: string | null;
  tenantUser?: TenantUserBasicModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyNeedGroupModelApiResultSuccess {
  returnValue?: PartyNeedGroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyNeedGroupModelIEnumerableApiResultSuccess {
  returnValue?: PartyNeedGroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyNeedModel {
  /** @format uuid */
  partyNeedGroupId?: string;

  /** @format uuid */
  needId?: string;
  need?: NeedModel;
  description?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyNeedModelApiResultSuccess {
  returnValue?: PartyNeedModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyNeedModelIEnumerableApiResultSuccess {
  returnValue?: PartyNeedModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyPeriodModel {
  /** @format uuid */
  partyId?: string;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;
  isLocked?: boolean;
  isLoweredPrice?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyPeriodModelApiResultSuccess {
  returnValue?: PartyPeriodModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyPeriodModelIEnumerableApiResultSuccess {
  returnValue?: PartyPeriodModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyPrintModel {
  printType?: PartyPrintTypeEnum;
}

export enum PartyPrintTypeEnum {
  General = "General",
  Interest = "Interest",
  Information = "Information",
  Evaluations = "Evaluations",
  Comments = "Comments",
  WorkTaskRules = "WorkTaskRules",
  VisitRules = "VisitRules",
}

export interface PartySocialInquiryGroupModel {
  partySocialInquiries?: PartySocialInquiryModel[] | null;
  createdBy?: UserBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  tenantUserId?: string | null;
  tenantUser?: TenantUserBasicModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartySocialInquiryGroupModelApiResultSuccess {
  returnValue?: PartySocialInquiryGroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartySocialInquiryGroupModelIEnumerableApiResultSuccess {
  returnValue?: PartySocialInquiryGroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartySocialInquiryModel {
  /** @format uuid */
  partySocialInquiryGroupId?: string;

  /** @format uuid */
  socialInquiryId?: string;
  socialInquiry?: SocialInquiryModel;
  description?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartySocialInquiryModelApiResultSuccess {
  returnValue?: PartySocialInquiryModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartySocialInquiryModelIEnumerableApiResultSuccess {
  returnValue?: PartySocialInquiryModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyWorkDayBasicModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  day?: string;

  /** @format int32 */
  remainingWorkTasks?: number;

  /** @format int32 */
  doneWorkTasks?: number;
  isDone?: boolean;
  isUserDefined?: boolean;
  isUserListCustomDefined?: boolean;

  /** @format uuid */
  visitRuleId?: string | null;
  visitRule?: VisitRuleBasicModel;

  /** @format uuid */
  partyPeriodId?: string;
  partyPeriod?: PartyPeriodModel;
  partyWorkDayUsers?: PartyWorkDayUserModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyWorkDayBasicModelIEnumerableApiResultSuccess {
  returnValue?: PartyWorkDayBasicModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyWorkDayModel {
  workTasks?: WorkTaskModel[] | null;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  day?: string;

  /** @format int32 */
  remainingWorkTasks?: number;

  /** @format int32 */
  doneWorkTasks?: number;
  isDone?: boolean;
  isUserDefined?: boolean;
  isUserListCustomDefined?: boolean;

  /** @format uuid */
  visitRuleId?: string | null;
  visitRule?: VisitRuleBasicModel;

  /** @format uuid */
  partyPeriodId?: string;
  partyPeriod?: PartyPeriodModel;
  partyWorkDayUsers?: PartyWorkDayUserModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyWorkDayModelApiResultSuccess {
  returnValue?: PartyWorkDayModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyWorkDayModelIEnumerableApiResultSuccess {
  returnValue?: PartyWorkDayModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyWorkDayUserModel {
  /** @format uuid */
  partyWorkDayId?: string;

  /** @format uuid */
  userId?: string;
  user?: UserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PartyWorkDayUserModelApiResultSuccess {
  returnValue?: PartyWorkDayUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyWorkDayUserModelIEnumerableApiResultSuccess {
  returnValue?: PartyWorkDayUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PatchBatchDocument {
  /** @format uuid */
  id?: string;
  query?: PredicateDefinition[] | null;
  operations?: Operation[] | null;
}

export interface PaymentModel {
  /** @format uuid */
  billingId?: string;
  billing?: BillingModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format uuid */
  paymentMethodId?: string;
  paymentMethod?: CodebookBasicModel;

  /** @format date-time */
  paidOn?: string;

  /** @format double */
  paidAmount?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PaymentModelApiResultSuccess {
  returnValue?: PaymentModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PaymentModelIEnumerableApiResultSuccess {
  returnValue?: PaymentModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PeriodLockModel {
  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PeriodLockModelApiResultSuccess {
  returnValue?: PeriodLockModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PeriodLockModelIEnumerableApiResultSuccess {
  returnValue?: PeriodLockModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PredicateDefinition {
  junction?: JunctionOperator;
  field?: string | null;
  op?: QueryOperator;
  comparand?: any;
}

export interface PriceListItemModel {
  /** @format uuid */
  priceListId?: string;

  /** @format uuid */
  catalogueItemId?: string;
  catalogueItem?: CatalogueItemBasicModel;

  /** @format double */
  unitPrice?: number;

  /** @format double */
  loweredUnitPrice?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PriceListModel {
  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;
  priceListItems?: PriceListItemModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PriceListModelApiResultSuccess {
  returnValue?: PriceListModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PriceListModelIEnumerableApiResultSuccess {
  returnValue?: PriceListModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PrintQueryModel {
  fileName?: string | null;
  date?: string | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum ProjectionAggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
  Min = "min",
  Max = "max",
}

export interface QueryModel {
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum QueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
  C = "c",
  Sw = "sw",
  Ew = "ew",
  In = "in",
  Wrap = "wrap",
}

export enum RepeatFrequencyEnum {
  Week = "Week",
  Month = "Month",
}

export interface ReportPrintQueryModel {
  printType?: ReportPrintTypeEnum;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;
  fileName?: string | null;
  date?: string | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum ReportPrintTypeEnum {
  Billings = "Billings",
  Receipts = "Receipts",
  PaymentPrescription = "PaymentPrescription",
  BillingByWorkTasks = "BillingByWorkTasks",
  BillingDebts = "BillingDebts",
  ProvidedWorkTasks = "ProvidedWorkTasks",
  ProvidedWorkTaskByClient = "ProvidedWorkTaskByClient",
  ProvidedWorkTaskByCareProvider = "ProvidedWorkTaskByCareProvider",
  ActivatedClients = "ActivatedClients",
  ArchivedClients = "ArchivedClients",
  Clients = "Clients",
  ClientsWithCareAllowence = "ClientsWithCareAllowence",
}

export interface ResetPasswordModel {
  /** @format email */
  email: string;
}

export interface SetPasswordModel {
  currentPassword: string;
  newPassword: string;
}

export enum SexEnum {
  Male = "Male",
  Female = "Female",
}

export interface SignUpModel {
  /** @format email */
  email: string;

  /** @format password */
  password: string;
  firstName: string;
  lastName: string;
  language: string;
  phoneNumber: string;
}

export interface SocialInquiryModel {
  name?: string | null;

  /** @format int32 */
  position?: number;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface SocialInquiryModelApiResultSuccess {
  returnValue?: SocialInquiryModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SocialInquiryModelIEnumerableApiResultSuccess {
  returnValue?: SocialInquiryModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export interface SystemUserModel {
  /** @format uuid */
  userId?: string;
  user?: UserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface SystemUserModelApiResultSuccess {
  returnValue?: SystemUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SystemUserModelIEnumerableApiResultSuccess {
  returnValue?: SystemUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantBaseModel {
  name?: string | null;
  domainName?: string | null;
  currency?: string | null;
  timeZone?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantInvitationModel {
  emailAddress?: string | null;
  isActive?: boolean;
  isAccepted?: boolean | null;

  /** @format date-time */
  acceptedOn?: string | null;

  /** @format uuid */
  tenantId?: string;
  tenant?: TenantBaseModel;
  accountType?: AccountTypeEnum;

  /** @format uuid */
  mainDistrictId?: string | null;
  mainDistrict?: DistrictModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TenantInvitationModelApiResultSuccess {
  returnValue?: TenantInvitationModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantInvitationModelIEnumerableApiResultSuccess {
  returnValue?: TenantInvitationModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantModel {
  identificationNumber?: string | null;
  address?: string | null;
  vat?: string | null;
  addressStreet?: string | null;
  addressCity?: string | null;
  addressZip?: string | null;

  /** @format double */
  evaluationRepeatEach?: number | null;
  evaluationRepeatFrequency?: RepeatFrequencyEnum;
  evaluationOnlyWorkDays?: boolean | null;

  /** @format uuid */
  avatar?: string | null;
  accountNumber?: string | null;
  currentTenantUser?: TenantUserModel;
  printHeader?: string | null;
  legalText?: string | null;
  enableCreateWorkTaskRuleByWorker?: boolean | null;
  enableEditClientByWorker?: boolean | null;
  enableEditClientOfAnotherWorkers?: boolean | null;
  useLoweredPrice?: boolean | null;

  /** @format double */
  loweredPriceFromHourAmount?: number | null;

  /** @format date-time */
  licenceToDate?: string | null;

  /** @format int32 */
  licenceUserCount?: number | null;
  name?: string | null;
  domainName?: string | null;
  currency?: string | null;
  timeZone?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantModelApiResultSuccess {
  returnValue?: TenantModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantModelIEnumerableApiResultSuccess {
  returnValue?: TenantModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantUserBasicModel {
  /** @format uuid */
  userId?: string;
  user?: UserModel;
  accountType?: AccountTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantUserModel {
  tenant?: TenantBaseModel;

  /** @format uuid */
  managerId?: string | null;
  manager?: UserModel;

  /** @format uuid */
  mainDistrictId?: string | null;
  mainDistrict?: DistrictModel;
  externalSystemId?: string | null;
  isActive?: boolean;

  /** @format uuid */
  userId?: string;
  user?: UserModel;
  accountType?: AccountTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantUserModelApiResultSuccess {
  returnValue?: TenantUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantUserModelIEnumerableApiResultSuccess {
  returnValue?: TenantUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TerminationReasonModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TerminationReasonModelApiResultSuccess {
  returnValue?: TerminationReasonModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TerminationReasonModelIEnumerableApiResultSuccess {
  returnValue?: TerminationReasonModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TownModel {
  /** @format uuid */
  districtId?: string;
  district?: DistrictModel;
  name?: string | null;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TownModelApiResultSuccess {
  returnValue?: TownModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TownModelIEnumerableApiResultSuccess {
  returnValue?: TownModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TransactionEmailModel {
  type?: TransactionEmailType;
  isSent?: boolean;

  /** @format date-time */
  sentAt?: string | null;
  emailAddress?: string | null;

  /** @format uuid */
  partyId?: string | null;

  /** @format uuid */
  billingId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TransactionEmailModelApiResultSuccess {
  returnValue?: TransactionEmailModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TransactionEmailModelIEnumerableApiResultSuccess {
  returnValue?: TransactionEmailModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum TransactionEmailType {
  Billing = "Billing",
  Receipt = "Receipt",
}

export interface UnitOfMeasureConversionModel {
  /** @format uuid */
  basicUnitOfMeasureId?: string;
  basicUnitOfMeasure?: UnitOfMeasureModel;

  /** @format uuid */
  reportedUnitOfMeasureId?: string;
  reportedUnitOfMeasure?: UnitOfMeasureModel;

  /** @format double */
  coefficient?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UnitOfMeasureConversionModelApiResultSuccess {
  returnValue?: UnitOfMeasureConversionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UnitOfMeasureConversionModelIEnumerableApiResultSuccess {
  returnValue?: UnitOfMeasureConversionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UnitOfMeasureModel {
  name?: string | null;
  nameIdentifier?: string | null;
  shortName?: string | null;
  shortNameIdentifier?: string | null;
  type?: UnitOfMeasureTypeEnum;
  defaultValue?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UnitOfMeasureModelApiResultSuccess {
  returnValue?: UnitOfMeasureModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UnitOfMeasureModelIEnumerableApiResultSuccess {
  returnValue?: UnitOfMeasureModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum UnitOfMeasureTypeEnum {
  Basic = "Basic",
  Reported = "Reported",
}

export interface UserBaseModel {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UserModel {
  email?: string | null;
  language?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface VisitRuleBasicModel {
  name?: string | null;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format double */
  repeatEach?: number | null;
  repeatFrequency?: RepeatFrequencyEnum;
  onMonday?: boolean;
  onTuesday?: boolean;
  onWednesday?: boolean;
  onThursday?: boolean;
  onFriday?: boolean;
  onSaturday?: boolean;
  onSunday?: boolean;

  /** @format int32 */
  dayOccurrence?: number;

  /** @format int32 */
  dayOfMonth?: number | null;

  /** @format date-span */
  fromTime?: string | null;

  /** @format date-span */
  toTime?: string | null;
  nextBusinessDayOnHoliday?: boolean;
  description?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface VisitRuleModel {
  visitRuleWorkTasks?: VisitRuleWorkTaskModel[] | null;
  name?: string | null;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format double */
  repeatEach?: number | null;
  repeatFrequency?: RepeatFrequencyEnum;
  onMonday?: boolean;
  onTuesday?: boolean;
  onWednesday?: boolean;
  onThursday?: boolean;
  onFriday?: boolean;
  onSaturday?: boolean;
  onSunday?: boolean;

  /** @format int32 */
  dayOccurrence?: number;

  /** @format int32 */
  dayOfMonth?: number | null;

  /** @format date-span */
  fromTime?: string | null;

  /** @format date-span */
  toTime?: string | null;
  nextBusinessDayOnHoliday?: boolean;
  description?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface VisitRuleModelApiResultSuccess {
  returnValue?: VisitRuleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface VisitRuleModelIEnumerableApiResultSuccess {
  returnValue?: VisitRuleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface VisitRuleWorkTaskModel {
  /** @format uuid */
  visitRuleId?: string;

  /** @format uuid */
  workTaskRuleId?: string;
  workTaskRule?: WorkTaskRuleBasicModel;
  description?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskBasicModel {
  /** @format uuid */
  partyWorkDayId?: string;
  partyWorkDay?: PartyWorkDayBasicModel;

  /** @format uuid */
  catalogueItemId?: string;
  catalogueItem?: CatalogueItemModel;

  /** @format uuid */
  workTaskRuleId?: string | null;
  workTaskRule?: WorkTaskRuleModel;

  /** @format uuid */
  visitRuleId?: string | null;

  /** @format date-time */
  time?: string;

  /** @format double */
  unitPrice?: number;

  /** @format double */
  standardUnitPrice?: number | null;

  /** @format double */
  loweredUnitPrice?: number | null;
  isLoweredUnitPrice?: boolean | null;
  isProvided?: boolean;

  /** @format int32 */
  dayOccurrence?: number | null;
  disablePerforming?: boolean;
  isUserDefined?: boolean;

  /** @format uuid */
  partyPeriodId?: string;
  partyPeriod?: PartyPeriodModel;

  /** @format uuid */
  visitRuleWorkTaskId?: string | null;
  visitRuleWorkTask?: VisitRuleWorkTaskModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskEvaluationGroupModel {
  workTaskEvaluations?: WorkTaskEvaluationModel[] | null;
  createdBy?: UserBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  tenantUserId?: string | null;
  tenantUser?: TenantUserBasicModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskEvaluationGroupModelApiResultSuccess {
  returnValue?: WorkTaskEvaluationGroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskEvaluationGroupModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskEvaluationGroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskEvaluationModel {
  /** @format uuid */
  workTaskEvaluationGroupId?: string;

  /** @format uuid */
  workTaskRuleId?: string;
  workTaskRule?: WorkTaskRuleModel;
  description?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskEvaluationModelApiResultSuccess {
  returnValue?: WorkTaskEvaluationModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskEvaluationModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskEvaluationModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskGroupModel {
  partyWorkDayUsers?: PartyWorkDayUserModel[] | null;
  workTasks?: WorkTaskModel[] | null;

  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format date-time */
  day?: string;

  /** @format int32 */
  remainingWorkTasks?: number;

  /** @format int32 */
  doneWorkTasks?: number;
  isDone?: boolean;
  isUserDefined?: boolean;
  isUserListCustomDefined?: boolean;

  /** @format uuid */
  visitRuleId?: string | null;
  visitRule?: VisitRuleBasicModel;

  /** @format uuid */
  partyPeriodId?: string;
  partyPeriod?: PartyPeriodModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskGroupModelApiResultSuccess {
  returnValue?: WorkTaskGroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskGroupModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskGroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskModel {
  workTaskStatements?: WorkTaskStatementModel[] | null;

  /** @format uuid */
  partyWorkDayId?: string;
  partyWorkDay?: PartyWorkDayBasicModel;

  /** @format uuid */
  catalogueItemId?: string;
  catalogueItem?: CatalogueItemModel;

  /** @format uuid */
  workTaskRuleId?: string | null;
  workTaskRule?: WorkTaskRuleModel;

  /** @format uuid */
  visitRuleId?: string | null;

  /** @format date-time */
  time?: string;

  /** @format double */
  unitPrice?: number;

  /** @format double */
  standardUnitPrice?: number | null;

  /** @format double */
  loweredUnitPrice?: number | null;
  isLoweredUnitPrice?: boolean | null;
  isProvided?: boolean;

  /** @format int32 */
  dayOccurrence?: number | null;
  disablePerforming?: boolean;
  isUserDefined?: boolean;

  /** @format uuid */
  partyPeriodId?: string;
  partyPeriod?: PartyPeriodModel;

  /** @format uuid */
  visitRuleWorkTaskId?: string | null;
  visitRuleWorkTask?: VisitRuleWorkTaskModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskModelApiResultSuccess {
  returnValue?: WorkTaskModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskPlanItemModel {
  /** @format uuid */
  partyId?: string;

  /** @format date-time */
  plannedUntil?: string;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskPlanItemModelApiResultSuccess {
  returnValue?: WorkTaskPlanItemModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskPlanItemModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskPlanItemModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskRuleBasicModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format uuid */
  catalogueItemId?: string;
  catalogueItem?: CatalogueItemModel;
  frequency?: FrequencyEnum;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  workTaskStateId?: string | null;
  workTaskState?: CodebookModel;
  description?: string | null;
  reason?: string | null;
  goal?: string | null;
  desire?: string | null;
  risk?: string | null;
  tools?: string | null;

  /** @format date-time */
  activationDate?: string | null;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskRuleModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBasicModel;

  /** @format uuid */
  catalogueItemId?: string;
  catalogueItem?: CatalogueItemModel;
  frequency?: FrequencyEnum;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format uuid */
  workTaskStateId?: string | null;
  workTaskState?: CodebookModel;
  description?: string | null;
  reason?: string | null;
  goal?: string | null;
  desire?: string | null;
  risk?: string | null;
  tools?: string | null;

  /** @format date-time */
  activationDate?: string | null;
  externalSystemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskRuleModelApiResultSuccess {
  returnValue?: WorkTaskRuleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskRuleModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskRuleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskStatementModel {
  /** @format uuid */
  billingId?: string | null;
  billing?: BillingModel;

  /** @format uuid */
  workTaskId?: string;

  /** @format int32 */
  visitNumber?: number;

  /** @format double */
  amount?: number;

  /** @format uuid */
  userId?: string;
  user?: UserBaseModel;
  workTask?: WorkTaskBasicModel;

  /** @format double */
  price?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkTaskStatementModelApiResultSuccess {
  returnValue?: WorkTaskStatementModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkTaskStatementModelIEnumerableApiResultSuccess {
  returnValue?: WorkTaskStatementModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((data, key) => {
        data.append(key, input[key]);
        return data;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = (null as unknown) as T;
      r.error = (null as unknown) as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title VeruApp API
 * @version 1.0
 * @license MIT (https://opensource.org/licenses/MIT)
 * @contact Support <info@nordelo.cz>
 *
 * A REST API service with Swagger, Swashbuckle, and API versioning.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Admin
     * @name RefreshCache
     * @request GET:/api/admin/refresh-cache
     */
    refreshCache: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/api/admin/refresh-cache`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminDeleteSystemUsers
     * @request DELETE:/api/admin/system-users
     * @secure
     */
    adminDeleteSystemUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminInsertSystemUser
     * @request POST:/api/admin/system-users
     * @secure
     */
    adminInsertSystemUser: (data: SystemUserModel, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserById
     * @request GET:/api/admin/system-users/{id}
     * @secure
     */
    adminGetSystemUserById: (id: string, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminPatchSystemUser
     * @request PATCH:/api/admin/system-users/{id}
     * @secure
     */
    adminPatchSystemUser: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminUpdateSystemUser
     * @request PUT:/api/admin/system-users/{id}
     * @secure
     */
    adminUpdateSystemUser: (id: string, data: SystemUserModel, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminAggregationSystemUser
     * @request POST:/api/admin/system-users/aggregation
     * @secure
     */
    adminAggregationSystemUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserGroupped
     * @request POST:/api/admin/system-users/groupped
     * @secure
     */
    adminGetSystemUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserBatch
     * @request POST:/api/admin/system-users/{pageIndex},{pageSize}
     * @secure
     */
    adminGetSystemUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminGetTenantById
     * @request GET:/api/admin/tenants/{id}
     * @secure
     */
    adminGetTenantById: (id: string, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminPatchTenant
     * @request PATCH:/api/admin/tenants/{id}
     * @secure
     */
    adminPatchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminUpdateTenant
     * @request PUT:/api/admin/tenants/{id}
     * @secure
     */
    adminUpdateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminInsertTenant
     * @request POST:/api/admin/tenants
     * @secure
     */
    adminInsertTenant: (data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminGetTenantBatch
     * @request POST:/api/admin/tenants/{pageIndex},{pageSize}
     * @secure
     */
    adminGetTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminDeleteTenantUsers
     * @request DELETE:/api/admin/tenant-users
     * @secure
     */
    adminDeleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminInsertTenantUser
     * @request POST:/api/admin/tenant-users
     * @secure
     */
    adminInsertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminGetTenantUserById
     * @request GET:/api/admin/tenant-users/{id}
     * @secure
     */
    adminGetTenantUserById: (id: string, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminUpdateTenantUser
     * @request PUT:/api/admin/tenant-users/{id}
     * @secure
     */
    adminUpdateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminAggregationTenantUser
     * @request POST:/api/admin/tenant-users/aggregation
     * @secure
     */
    adminAggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminGetTenantUserBatch
     * @request POST:/api/admin/tenant-users/{pageIndex},{pageSize}
     * @secure
     */
    adminGetTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetAdminUserById
     * @request GET:/api/admin/users/{id}
     * @secure
     */
    getAdminUserById: (id: string, params: RequestParams = {}) =>
      this.request<AdminUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetAdminUserBatch
     * @request POST:/api/admin/users/{pageIndex},{pageSize}
     * @secure
     */
    getAdminUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<AdminUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name DeleteBillings
     * @request DELETE:/api/billings
     * @secure
     */
    deleteBillings: (data: QueryModel, params: RequestParams = {}) =>
      this.request<BillingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name InsertBilling
     * @request POST:/api/billings
     * @secure
     */
    insertBilling: (data: BillingModel, params: RequestParams = {}) =>
      this.request<BillingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name GetBillingById
     * @request GET:/api/billings/{id}
     * @secure
     */
    getBillingById: (id: string, params: RequestParams = {}) =>
      this.request<BillingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name PatchBilling
     * @request PATCH:/api/billings/{id}
     * @secure
     */
    patchBilling: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<BillingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name UpdateBilling
     * @request PUT:/api/billings/{id}
     * @secure
     */
    updateBilling: (id: string, data: BillingModel, params: RequestParams = {}) =>
      this.request<BillingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name PatchBatchBilling
     * @request PATCH:/api/billings/batch
     * @secure
     */
    patchBatchBilling: (data: PatchBatchDocument[], params: RequestParams = {}) =>
      this.request<BillingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/batch`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name AggregationBilling
     * @request POST:/api/billings/aggregation
     * @secure
     */
    aggregationBilling: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name GetBillingGroupped
     * @request POST:/api/billings/groupped
     * @secure
     */
    getBillingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name GetBillingBatch
     * @request POST:/api/billings/{pageIndex},{pageSize}
     * @secure
     */
    getBillingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<BillingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/billings/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name DeleteCareAllowences
     * @request DELETE:/api/care-allowences
     * @secure
     */
    deleteCareAllowences: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CareAllowenceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name InsertCareAllowence
     * @request POST:/api/care-allowences
     * @secure
     */
    insertCareAllowence: (data: CareAllowenceModel, params: RequestParams = {}) =>
      this.request<CareAllowenceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name GetCareAllowenceById
     * @request GET:/api/care-allowences/{id}
     * @secure
     */
    getCareAllowenceById: (id: string, params: RequestParams = {}) =>
      this.request<CareAllowenceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name PatchCareAllowence
     * @request PATCH:/api/care-allowences/{id}
     * @secure
     */
    patchCareAllowence: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CareAllowenceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name UpdateCareAllowence
     * @request PUT:/api/care-allowences/{id}
     * @secure
     */
    updateCareAllowence: (id: string, data: CareAllowenceModel, params: RequestParams = {}) =>
      this.request<CareAllowenceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name AggregationCareAllowence
     * @request POST:/api/care-allowences/aggregation
     * @secure
     */
    aggregationCareAllowence: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareAllowences
     * @name GetCareAllowenceBatch
     * @request POST:/api/care-allowences/{pageIndex},{pageSize}
     * @secure
     */
    getCareAllowenceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CareAllowenceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/care-allowences/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name DeleteCatalogueItems
     * @request DELETE:/api/catalogue-items
     * @secure
     */
    deleteCatalogueItems: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CatalogueItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name InsertCatalogueItem
     * @request POST:/api/catalogue-items
     * @secure
     */
    insertCatalogueItem: (data: CatalogueItemModel, params: RequestParams = {}) =>
      this.request<CatalogueItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name GetCatalogueItemById
     * @request GET:/api/catalogue-items/{id}
     * @secure
     */
    getCatalogueItemById: (id: string, params: RequestParams = {}) =>
      this.request<CatalogueItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name PatchCatalogueItem
     * @request PATCH:/api/catalogue-items/{id}
     * @secure
     */
    patchCatalogueItem: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CatalogueItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name UpdateCatalogueItem
     * @request PUT:/api/catalogue-items/{id}
     * @secure
     */
    updateCatalogueItem: (id: string, data: CatalogueItemModel, params: RequestParams = {}) =>
      this.request<CatalogueItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name AggregationCatalogueItem
     * @request POST:/api/catalogue-items/aggregation
     * @secure
     */
    aggregationCatalogueItem: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name GetCatalogueItemBatch
     * @request POST:/api/catalogue-items/{pageIndex},{pageSize}
     * @secure
     */
    getCatalogueItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CatalogueItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CatalogueItems
     * @name ExportCatalogueItemBatch
     * @request POST:/api/catalogue-items/{pageIndex},{pageSize}/export
     * @secure
     */
    exportCatalogueItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/catalogue-items/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closings
     * @name MakeClosingBatch
     * @request POST:/api/closings/make
     * @secure
     */
    makeClosingBatch: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ClosingModelPagedResultApiResultSuccess, ApiResultFailed | void>({
        path: `/api/closings/make`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closings
     * @name GetClosingBatch
     * @request POST:/api/closings/{pageIndex},{pageSize}
     * @secure
     */
    getClosingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ClosingModelPagedResultApiResultSuccess, ApiResultFailed | void>({
        path: `/api/closings/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookById
     * @request GET:/api/codebooks/{id}
     * @secure
     */
    getCodebookById: (id: string, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookBatch
     * @request POST:/api/codebooks/{pageIndex},{pageSize}
     * @secure
     */
    getCodebookBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name DeleteDistricts
     * @request DELETE:/api/districts
     * @secure
     */
    deleteDistricts: (data: QueryModel, params: RequestParams = {}) =>
      this.request<DistrictModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name InsertDistrict
     * @request POST:/api/districts
     * @secure
     */
    insertDistrict: (data: DistrictModel, params: RequestParams = {}) =>
      this.request<DistrictModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name GetDistrictById
     * @request GET:/api/districts/{id}
     * @secure
     */
    getDistrictById: (id: string, params: RequestParams = {}) =>
      this.request<DistrictModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name PatchDistrict
     * @request PATCH:/api/districts/{id}
     * @secure
     */
    patchDistrict: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<DistrictModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name UpdateDistrict
     * @request PUT:/api/districts/{id}
     * @secure
     */
    updateDistrict: (id: string, data: DistrictModel, params: RequestParams = {}) =>
      this.request<DistrictModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name AggregationDistrict
     * @request POST:/api/districts/aggregation
     * @secure
     */
    aggregationDistrict: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Districts
     * @name GetDistrictBatch
     * @request POST:/api/districts/{pageIndex},{pageSize}
     * @secure
     */
    getDistrictBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<DistrictModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/districts/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name DeleteFiles
     * @request DELETE:/api/files
     * @secure
     */
    deleteFiles: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileById
     * @request GET:/api/files/{id}
     * @secure
     */
    getFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PatchFile
     * @request PATCH:/api/files/{id}
     * @secure
     */
    patchFile: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name UpdateFile
     * @request PUT:/api/files/{id}
     * @secure
     */
    updateFile: (id: string, data: FileModel, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name AggregationFile
     * @request POST:/api/files/aggregation
     * @secure
     */
    aggregationFile: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileBatch
     * @request POST:/api/files/{pageIndex},{pageSize}
     * @secure
     */
    getFileBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name DeleteFolders
     * @request DELETE:/api/folders
     * @secure
     */
    deleteFolders: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FolderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name InsertFolder
     * @request POST:/api/folders
     * @secure
     */
    insertFolder: (data: FolderModel, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderById
     * @request GET:/api/folders/{id}
     * @secure
     */
    getFolderById: (id: string, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PatchFolder
     * @request PATCH:/api/folders/{id}
     * @secure
     */
    patchFolder: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name UpdateFolder
     * @request PUT:/api/folders/{id}
     * @secure
     */
    updateFolder: (id: string, data: FolderModel, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name AggregationFolder
     * @request POST:/api/folders/aggregation
     * @secure
     */
    aggregationFolder: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderBatch
     * @request POST:/api/folders/{pageIndex},{pageSize}
     * @secure
     */
    getFolderBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FolderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateAvatar
     * @request PUT:/api/me/avatar
     * @secure
     */
    updateAvatar: (data: AvatarUploadModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name GetApplicationUser
     * @request GET:/api/me
     * @secure
     */
    getApplicationUser: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateApplicationUser
     * @request PUT:/api/me
     * @secure
     */
    updateApplicationUser: (data: ApplicationUserModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name DeleteNeeds
     * @request DELETE:/api/needs
     * @secure
     */
    deleteNeeds: (data: QueryModel, params: RequestParams = {}) =>
      this.request<NeedModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name InsertNeed
     * @request POST:/api/needs
     * @secure
     */
    insertNeed: (data: NeedModel, params: RequestParams = {}) =>
      this.request<NeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name GetNeedById
     * @request GET:/api/needs/{id}
     * @secure
     */
    getNeedById: (id: string, params: RequestParams = {}) =>
      this.request<NeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name PatchNeed
     * @request PATCH:/api/needs/{id}
     * @secure
     */
    patchNeed: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<NeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name UpdateNeed
     * @request PUT:/api/needs/{id}
     * @secure
     */
    updateNeed: (id: string, data: NeedModel, params: RequestParams = {}) =>
      this.request<NeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name PatchBatchNeed
     * @request PATCH:/api/needs/batch
     * @secure
     */
    patchBatchNeed: (data: PatchBatchDocument[], params: RequestParams = {}) =>
      this.request<NeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/batch`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name AggregationNeed
     * @request POST:/api/needs/aggregation
     * @secure
     */
    aggregationNeed: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Needs
     * @name GetNeedBatch
     * @request POST:/api/needs/{pageIndex},{pageSize}
     * @secure
     */
    getNeedBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<NeedModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/needs/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name DeleteParties
     * @request DELETE:/api/parties
     * @secure
     */
    deleteParties: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name InsertParty
     * @request POST:/api/parties
     * @secure
     */
    insertParty: (data: PartyModel, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyById
     * @request GET:/api/parties/{id}
     * @secure
     */
    getPartyById: (id: string, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name PatchParty
     * @request PATCH:/api/parties/{id}
     * @secure
     */
    patchParty: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name UpdateParty
     * @request PUT:/api/parties/{id}
     * @secure
     */
    updateParty: (id: string, data: PartyModel, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name AggregationParty
     * @request POST:/api/parties/aggregation
     * @secure
     */
    aggregationParty: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyGroupped
     * @request POST:/api/parties/groupped
     * @secure
     */
    getPartyGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name PrintParty
     * @request POST:/api/parties/{id}/print
     * @secure
     */
    printParty: (id: string, data: PartyPrintModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}/print`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyBasicBatch
     * @request POST:/api/parties/{pageIndex},{pageSize}/basic
     * @secure
     */
    getPartyBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${pageIndex},${pageSize}/basic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyBatch
     * @request POST:/api/parties/{pageIndex},{pageSize}
     * @secure
     */
    getPartyBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name ExportPartyBatch
     * @request POST:/api/parties/{pageIndex},{pageSize}/export
     * @secure
     */
    exportPartyBatch: (pageIndex: number, pageSize: number, data: PartyExportModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name DeletePartyActivities
     * @request DELETE:/api/party-activities
     * @secure
     */
    deletePartyActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name InsertPartyActivity
     * @request POST:/api/party-activities
     * @secure
     */
    insertPartyActivity: (data: PartyActivityModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name GetPartyActivityById
     * @request GET:/api/party-activities/{id}
     * @secure
     */
    getPartyActivityById: (id: string, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name PatchPartyActivity
     * @request PATCH:/api/party-activities/{id}
     * @secure
     */
    patchPartyActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name UpdatePartyActivity
     * @request PUT:/api/party-activities/{id}
     * @secure
     */
    updatePartyActivity: (id: string, data: PartyActivityModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name AggregationPartyActivity
     * @request POST:/api/party-activities/aggregation
     * @secure
     */
    aggregationPartyActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name GetPartyActivityBatch
     * @request POST:/api/party-activities/{pageIndex},{pageSize}
     * @secure
     */
    getPartyActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-activities/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name DeletePartyCareProviders
     * @request DELETE:/api/party-care-providers
     * @secure
     */
    deletePartyCareProviders: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyCareProviderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name InsertPartyCareProvider
     * @request POST:/api/party-care-providers
     * @secure
     */
    insertPartyCareProvider: (data: PartyCareProviderModel, params: RequestParams = {}) =>
      this.request<PartyCareProviderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name GetPartyCareProviderById
     * @request GET:/api/party-care-providers/{id}
     * @secure
     */
    getPartyCareProviderById: (id: string, params: RequestParams = {}) =>
      this.request<PartyCareProviderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name PatchPartyCareProvider
     * @request PATCH:/api/party-care-providers/{id}
     * @secure
     */
    patchPartyCareProvider: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyCareProviderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name UpdatePartyCareProvider
     * @request PUT:/api/party-care-providers/{id}
     * @secure
     */
    updatePartyCareProvider: (id: string, data: PartyCareProviderModel, params: RequestParams = {}) =>
      this.request<PartyCareProviderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name AggregationPartyCareProvider
     * @request POST:/api/party-care-providers/aggregation
     * @secure
     */
    aggregationPartyCareProvider: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCareProviders
     * @name GetPartyCareProviderBatch
     * @request POST:/api/party-care-providers/{pageIndex},{pageSize}
     * @secure
     */
    getPartyCareProviderBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyCareProviderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-care-providers/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name DeletePartyContacts
     * @request DELETE:/api/party-contacts
     * @secure
     */
    deletePartyContacts: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyContactModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name InsertPartyContact
     * @request POST:/api/party-contacts
     * @secure
     */
    insertPartyContact: (data: PartyContactModel, params: RequestParams = {}) =>
      this.request<PartyContactModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name GetPartyContactById
     * @request GET:/api/party-contacts/{id}
     * @secure
     */
    getPartyContactById: (id: string, params: RequestParams = {}) =>
      this.request<PartyContactModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name PatchPartyContact
     * @request PATCH:/api/party-contacts/{id}
     * @secure
     */
    patchPartyContact: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyContactModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name UpdatePartyContact
     * @request PUT:/api/party-contacts/{id}
     * @secure
     */
    updatePartyContact: (id: string, data: PartyContactModel, params: RequestParams = {}) =>
      this.request<PartyContactModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name AggregationPartyContact
     * @request POST:/api/party-contacts/aggregation
     * @secure
     */
    aggregationPartyContact: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyContacts
     * @name GetPartyContactBatch
     * @request POST:/api/party-contacts/{pageIndex},{pageSize}
     * @secure
     */
    getPartyContactBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyContactModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-contacts/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name DeletePartyNeedGroups
     * @request DELETE:/api/party-need-groups
     * @secure
     */
    deletePartyNeedGroups: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name InsertPartyNeedGroup
     * @request POST:/api/party-need-groups
     * @secure
     */
    insertPartyNeedGroup: (data: PartyNeedGroupModel, params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name GetPartyNeedGroupById
     * @request GET:/api/party-need-groups/{id}
     * @secure
     */
    getPartyNeedGroupById: (id: string, params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name PatchPartyNeedGroup
     * @request PATCH:/api/party-need-groups/{id}
     * @secure
     */
    patchPartyNeedGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name UpdatePartyNeedGroup
     * @request PUT:/api/party-need-groups/{id}
     * @secure
     */
    updatePartyNeedGroup: (id: string, data: PartyNeedGroupModel, params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name PrintPartyNeedGroupById
     * @request GET:/api/party-need-groups/{id}/print
     * @secure
     */
    printPartyNeedGroupById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name AggregationPartyNeedGroup
     * @request POST:/api/party-need-groups/aggregation
     * @secure
     */
    aggregationPartyNeedGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeedGroups
     * @name GetPartyNeedGroupBatch
     * @request POST:/api/party-need-groups/{pageIndex},{pageSize}
     * @secure
     */
    getPartyNeedGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyNeedGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-need-groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name DeletePartyNeeds
     * @request DELETE:/api/party-needs
     * @secure
     */
    deletePartyNeeds: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyNeedModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name InsertPartyNeed
     * @request POST:/api/party-needs
     * @secure
     */
    insertPartyNeed: (data: PartyNeedModel, params: RequestParams = {}) =>
      this.request<PartyNeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name GetPartyNeedById
     * @request GET:/api/party-needs/{id}
     * @secure
     */
    getPartyNeedById: (id: string, params: RequestParams = {}) =>
      this.request<PartyNeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name PatchPartyNeed
     * @request PATCH:/api/party-needs/{id}
     * @secure
     */
    patchPartyNeed: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyNeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name UpdatePartyNeed
     * @request PUT:/api/party-needs/{id}
     * @secure
     */
    updatePartyNeed: (id: string, data: PartyNeedModel, params: RequestParams = {}) =>
      this.request<PartyNeedModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name AggregationPartyNeed
     * @request POST:/api/party-needs/aggregation
     * @secure
     */
    aggregationPartyNeed: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyNeeds
     * @name GetPartyNeedBatch
     * @request POST:/api/party-needs/{pageIndex},{pageSize}
     * @secure
     */
    getPartyNeedBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyNeedModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-needs/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name GetPartyPeriodById
     * @request GET:/api/party-periods/{id}
     * @secure
     */
    getPartyPeriodById: (id: string, params: RequestParams = {}) =>
      this.request<PartyPeriodModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name UpdatePartyPeriod
     * @request PUT:/api/party-periods/{id}
     * @secure
     */
    updatePartyPeriod: (id: string, data: PartyPeriodModel, params: RequestParams = {}) =>
      this.request<PartyPeriodModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name InsertPartyPeriod
     * @request POST:/api/party-periods
     * @secure
     */
    insertPartyPeriod: (data: PartyPeriodModel, params: RequestParams = {}) =>
      this.request<PartyPeriodModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name AggregationPartyPeriod
     * @request POST:/api/party-periods/aggregation
     * @secure
     */
    aggregationPartyPeriod: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name GetPartyPeriodGroupped
     * @request POST:/api/party-periods/groupped
     * @secure
     */
    getPartyPeriodGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyPeriods
     * @name GetPartyPeriodBatch
     * @request POST:/api/party-periods/{pageIndex},{pageSize}
     * @secure
     */
    getPartyPeriodBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyPeriodModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-periods/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name DeletePartySocialInquiries
     * @request DELETE:/api/party-social-inquiries
     * @secure
     */
    deletePartySocialInquiries: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name InsertPartySocialInquiry
     * @request POST:/api/party-social-inquiries
     * @secure
     */
    insertPartySocialInquiry: (data: PartySocialInquiryModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name GetPartySocialInquiryById
     * @request GET:/api/party-social-inquiries/{id}
     * @secure
     */
    getPartySocialInquiryById: (id: string, params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name PatchPartySocialInquiry
     * @request PATCH:/api/party-social-inquiries/{id}
     * @secure
     */
    patchPartySocialInquiry: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name UpdatePartySocialInquiry
     * @request PUT:/api/party-social-inquiries/{id}
     * @secure
     */
    updatePartySocialInquiry: (id: string, data: PartySocialInquiryModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name AggregationPartySocialInquiry
     * @request POST:/api/party-social-inquiries/aggregation
     * @secure
     */
    aggregationPartySocialInquiry: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiries
     * @name GetPartySocialInquiryBatch
     * @request POST:/api/party-social-inquiries/{pageIndex},{pageSize}
     * @secure
     */
    getPartySocialInquiryBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiries/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name DeletePartySocialInquiryGroups
     * @request DELETE:/api/party-social-inquiry-groups
     * @secure
     */
    deletePartySocialInquiryGroups: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name InsertPartySocialInquiryGroup
     * @request POST:/api/party-social-inquiry-groups
     * @secure
     */
    insertPartySocialInquiryGroup: (data: PartySocialInquiryGroupModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name GetPartySocialInquiryGroupById
     * @request GET:/api/party-social-inquiry-groups/{id}
     * @secure
     */
    getPartySocialInquiryGroupById: (id: string, params: RequestParams = {}) =>
      this.request<PartySocialInquiryGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name PatchPartySocialInquiryGroup
     * @request PATCH:/api/party-social-inquiry-groups/{id}
     * @secure
     */
    patchPartySocialInquiryGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartySocialInquiryGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name UpdatePartySocialInquiryGroup
     * @request PUT:/api/party-social-inquiry-groups/{id}
     * @secure
     */
    updatePartySocialInquiryGroup: (id: string, data: PartySocialInquiryGroupModel, params: RequestParams = {}) =>
      this.request<PartySocialInquiryGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name PrintSocialInquiryGroupById
     * @request GET:/api/party-social-inquiry-groups/{id}/print
     * @secure
     */
    printSocialInquiryGroupById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name AggregationPartySocialInquiryGroup
     * @request POST:/api/party-social-inquiry-groups/aggregation
     * @secure
     */
    aggregationPartySocialInquiryGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartySocialInquiryGroups
     * @name GetPartySocialInquiryGroupBatch
     * @request POST:/api/party-social-inquiry-groups/{pageIndex},{pageSize}
     * @secure
     */
    getPartySocialInquiryGroupBatch: (
      pageIndex: number,
      pageSize: number,
      data: QueryModel,
      params: RequestParams = {},
    ) =>
      this.request<PartySocialInquiryGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-social-inquiry-groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name DeletePartyWorkDays
     * @request DELETE:/api/party-work-days
     * @secure
     */
    deletePartyWorkDays: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name InsertPartyWorkDay
     * @request POST:/api/party-work-days
     * @secure
     */
    insertPartyWorkDay: (data: PartyWorkDayModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name GetPartyWorkDayById
     * @request GET:/api/party-work-days/{id}
     * @secure
     */
    getPartyWorkDayById: (id: string, params: RequestParams = {}) =>
      this.request<PartyWorkDayModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name UpdatePartyWorkDay
     * @request PUT:/api/party-work-days/{id}
     * @secure
     */
    updatePartyWorkDay: (id: string, data: PartyWorkDayModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name AggregationPartyWorkDay
     * @request POST:/api/party-work-days/aggregation
     * @secure
     */
    aggregationPartyWorkDay: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name GetPartyWorkDayGroupped
     * @request POST:/api/party-work-days/groupped
     * @secure
     */
    getPartyWorkDayGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name PrintPartyWorkDayBatch
     * @request POST:/api/party-work-days/print
     * @secure
     */
    printPartyWorkDayBatch: (data: PrintQueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/print`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name GetPartyWorkDayBasicBatch
     * @request POST:/api/party-work-days/{pageIndex},{pageSize}/basic
     * @secure
     */
    getPartyWorkDayBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/${pageIndex},${pageSize}/basic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDays
     * @name GetPartyWorkDayBatch
     * @request POST:/api/party-work-days/{pageIndex},{pageSize}
     * @secure
     */
    getPartyWorkDayBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-days/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDayUsers
     * @name GetPartyWorkDayUserById
     * @request GET:/api/party-work-day-users/{id}
     * @secure
     */
    getPartyWorkDayUserById: (id: string, params: RequestParams = {}) =>
      this.request<PartyWorkDayUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-day-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDayUsers
     * @name AggregationPartyWorkDayUser
     * @request POST:/api/party-work-day-users/aggregation
     * @secure
     */
    aggregationPartyWorkDayUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-day-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyWorkDayUsers
     * @name GetPartyWorkDayUserBatch
     * @request POST:/api/party-work-day-users/{pageIndex},{pageSize}
     * @secure
     */
    getPartyWorkDayUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyWorkDayUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-work-day-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name DeletePayments
     * @request DELETE:/api/payments
     * @secure
     */
    deletePayments: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PaymentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name InsertPayment
     * @request POST:/api/payments
     * @secure
     */
    insertPayment: (data: PaymentModel, params: RequestParams = {}) =>
      this.request<PaymentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name GetPaymentById
     * @request GET:/api/payments/{id}
     * @secure
     */
    getPaymentById: (id: string, params: RequestParams = {}) =>
      this.request<PaymentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PatchPayment
     * @request PATCH:/api/payments/{id}
     * @secure
     */
    patchPayment: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PaymentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name UpdatePayment
     * @request PUT:/api/payments/{id}
     * @secure
     */
    updatePayment: (id: string, data: PaymentModel, params: RequestParams = {}) =>
      this.request<PaymentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name AggregationPayment
     * @request POST:/api/payments/aggregation
     * @secure
     */
    aggregationPayment: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name GetPaymentBatch
     * @request POST:/api/payments/{pageIndex},{pageSize}
     * @secure
     */
    getPaymentBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PaymentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/payments/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name GetPeriodLockById
     * @request GET:/api/period-locks/{id}
     * @secure
     */
    getPeriodLockById: (id: string, params: RequestParams = {}) =>
      this.request<PeriodLockModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name UpdatePeriodLock
     * @request PUT:/api/period-locks/{id}
     * @secure
     */
    updatePeriodLock: (id: string, data: PeriodLockModel, params: RequestParams = {}) =>
      this.request<PeriodLockModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name InsertPeriodLock
     * @request POST:/api/period-locks
     * @secure
     */
    insertPeriodLock: (data: PeriodLockModel, params: RequestParams = {}) =>
      this.request<PeriodLockModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name AggregationPeriodLock
     * @request POST:/api/period-locks/aggregation
     * @secure
     */
    aggregationPeriodLock: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name GetPeriodLockGroupped
     * @request POST:/api/period-locks/groupped
     * @secure
     */
    getPeriodLockGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PeriodLocks
     * @name GetPeriodLockBatch
     * @request POST:/api/period-locks/{pageIndex},{pageSize}
     * @secure
     */
    getPeriodLockBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PeriodLockModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/period-locks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name DeletePriceLists
     * @request DELETE:/api/price-lists
     * @secure
     */
    deletePriceLists: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PriceListModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name InsertPriceList
     * @request POST:/api/price-lists
     * @secure
     */
    insertPriceList: (data: PriceListModel, params: RequestParams = {}) =>
      this.request<PriceListModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name GetPriceListById
     * @request GET:/api/price-lists/{id}
     * @secure
     */
    getPriceListById: (id: string, params: RequestParams = {}) =>
      this.request<PriceListModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name PatchPriceList
     * @request PATCH:/api/price-lists/{id}
     * @secure
     */
    patchPriceList: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PriceListModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name UpdatePriceList
     * @request PUT:/api/price-lists/{id}
     * @secure
     */
    updatePriceList: (id: string, data: PriceListModel, params: RequestParams = {}) =>
      this.request<PriceListModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name AggregationPriceList
     * @request POST:/api/price-lists/aggregation
     * @secure
     */
    aggregationPriceList: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PriceLists
     * @name GetPriceListBatch
     * @request POST:/api/price-lists/{pageIndex},{pageSize}
     * @secure
     */
    getPriceListBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PriceListModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/price-lists/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportBatch
     * @request POST:/api/reports
     * @secure
     */
    reportBatch: (data: ReportPrintQueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name PrintReportBatch
     * @request POST:/api/reports/print
     * @secure
     */
    printReportBatch: (data: ReportPrintQueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/reports/print`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ResetPassword
     * @request POST:/api/reset-password
     */
    resetPassword: (data: ResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ConfirmResetPassword
     * @request POST:/api/reset-password/confirm
     */
    confirmResetPassword: (data: ConfirmResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SetPassword
     * @name SetPassword
     * @request POST:/api/set-password
     * @secure
     */
    setPassword: (data: SetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, void>({
        path: `/api/set-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignOut
     * @name SignOut
     * @request POST:/api/sign-out
     */
    signOut: (params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-out`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignUp
     * @name SignUp
     * @request POST:/api/sign-up
     */
    signUp: (data: SignUpModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-up`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignUp
     * @name ActivateAccount
     * @request POST:/api/sign-up/confirm
     */
    activateAccount: (data: ConfirmEmailModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-up/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name DeleteSocialInquiries
     * @request DELETE:/api/social-inquiries
     * @secure
     */
    deleteSocialInquiries: (data: QueryModel, params: RequestParams = {}) =>
      this.request<SocialInquiryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name InsertSocialInquiry
     * @request POST:/api/social-inquiries
     * @secure
     */
    insertSocialInquiry: (data: SocialInquiryModel, params: RequestParams = {}) =>
      this.request<SocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name GetSocialInquiryById
     * @request GET:/api/social-inquiries/{id}
     * @secure
     */
    getSocialInquiryById: (id: string, params: RequestParams = {}) =>
      this.request<SocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name PatchSocialInquiry
     * @request PATCH:/api/social-inquiries/{id}
     * @secure
     */
    patchSocialInquiry: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<SocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name UpdateSocialInquiry
     * @request PUT:/api/social-inquiries/{id}
     * @secure
     */
    updateSocialInquiry: (id: string, data: SocialInquiryModel, params: RequestParams = {}) =>
      this.request<SocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name PatchBatchSocialInquiry
     * @request PATCH:/api/social-inquiries/batch
     * @secure
     */
    patchBatchSocialInquiry: (data: PatchBatchDocument[], params: RequestParams = {}) =>
      this.request<SocialInquiryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/batch`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name AggregationSocialInquiry
     * @request POST:/api/social-inquiries/aggregation
     * @secure
     */
    aggregationSocialInquiry: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SocialInquiries
     * @name GetSocialInquiryBatch
     * @request POST:/api/social-inquiries/{pageIndex},{pageSize}
     * @secure
     */
    getSocialInquiryBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<SocialInquiryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/social-inquiries/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name DeleteTenantConnection
     * @request DELETE:/api/tenant-connections
     * @secure
     */
    deleteTenantConnection: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name InsertTenantConnection
     * @request POST:/api/tenant-connections
     * @secure
     */
    insertTenantConnection: (data: TenantInvitationModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name GetTenantConnectionBatch
     * @request POST:/api/tenant-connections/{pageIndex},{pageSize}
     * @secure
     */
    getTenantConnectionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name DeleteTenantInvitations
     * @request DELETE:/api/tenant-invitations
     * @secure
     */
    deleteTenantInvitations: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name DeleteTenantClientInvitations
     * @request DELETE:/api/tenant-invitations/client
     * @secure
     */
    deleteTenantClientInvitations: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/client`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name GetTenantInvitationById
     * @request GET:/api/tenant-invitations/{id}
     * @secure
     */
    getTenantInvitationById: (id: string, params: RequestParams = {}) =>
      this.request<TenantInvitationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name GetTenantInvitationBatch
     * @request POST:/api/tenant-invitations/{pageIndex},{pageSize}
     * @secure
     */
    getTenantInvitationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name UpdateTenantAvatar
     * @request PUT:/api/tenants/{id}/avatar
     * @secure
     */
    updateTenantAvatar: (id: string, data: AvatarUploadModel, params: RequestParams = {}) =>
      this.request<AvatarUploadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${id}/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name GetTenantById
     * @request GET:/api/tenants/{id}
     * @secure
     */
    getTenantById: (id: string, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name PatchTenant
     * @request PATCH:/api/tenants/{id}
     * @secure
     */
    patchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<void, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name UpdateTenant
     * @request PUT:/api/tenants/{id}
     * @secure
     */
    updateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
      this.request<void, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name InsertTenant
     * @request POST:/api/tenants
     * @secure
     */
    insertTenant: (data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name GetTenantBatch
     * @request POST:/api/tenants/{pageIndex},{pageSize}
     * @secure
     */
    getTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name DeleteTenantUsers
     * @request DELETE:/api/tenant-users
     * @secure
     */
    deleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name InsertTenantUser
     * @request POST:/api/tenant-users
     * @secure
     */
    insertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name GetTenantUserById
     * @request GET:/api/tenant-users/{id}
     * @secure
     */
    getTenantUserById: (id: string, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name UpdateTenantUser
     * @request PUT:/api/tenant-users/{id}
     * @secure
     */
    updateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name AggregationTenantUser
     * @request POST:/api/tenant-users/aggregation
     * @secure
     */
    aggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name GetTenantUserBatch
     * @request POST:/api/tenant-users/{pageIndex},{pageSize}
     * @secure
     */
    getTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name DeleteTerminationReasons
     * @request DELETE:/api/termination-reasons
     * @secure
     */
    deleteTerminationReasons: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TerminationReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name InsertTerminationReason
     * @request POST:/api/termination-reasons
     * @secure
     */
    insertTerminationReason: (data: TerminationReasonModel, params: RequestParams = {}) =>
      this.request<TerminationReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name GetTerminationReasonById
     * @request GET:/api/termination-reasons/{id}
     * @secure
     */
    getTerminationReasonById: (id: string, params: RequestParams = {}) =>
      this.request<TerminationReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name PatchTerminationReason
     * @request PATCH:/api/termination-reasons/{id}
     * @secure
     */
    patchTerminationReason: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TerminationReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name UpdateTerminationReason
     * @request PUT:/api/termination-reasons/{id}
     * @secure
     */
    updateTerminationReason: (id: string, data: TerminationReasonModel, params: RequestParams = {}) =>
      this.request<TerminationReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name AggregationTerminationReason
     * @request POST:/api/termination-reasons/aggregation
     * @secure
     */
    aggregationTerminationReason: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerminationReasons
     * @name GetTerminationReasonBatch
     * @request POST:/api/termination-reasons/{pageIndex},{pageSize}
     * @secure
     */
    getTerminationReasonBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TerminationReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/termination-reasons/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name DeleteTowns
     * @request DELETE:/api/towns
     * @secure
     */
    deleteTowns: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TownModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name InsertTown
     * @request POST:/api/towns
     * @secure
     */
    insertTown: (data: TownModel, params: RequestParams = {}) =>
      this.request<TownModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name GetTownById
     * @request GET:/api/towns/{id}
     * @secure
     */
    getTownById: (id: string, params: RequestParams = {}) =>
      this.request<TownModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name PatchTown
     * @request PATCH:/api/towns/{id}
     * @secure
     */
    patchTown: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TownModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name UpdateTown
     * @request PUT:/api/towns/{id}
     * @secure
     */
    updateTown: (id: string, data: TownModel, params: RequestParams = {}) =>
      this.request<TownModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name AggregationTown
     * @request POST:/api/towns/aggregation
     * @secure
     */
    aggregationTown: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Towns
     * @name GetTownBatch
     * @request POST:/api/towns/{pageIndex},{pageSize}
     * @secure
     */
    getTownBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TownModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/towns/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmails
     * @name GetTransactionEmailById
     * @request GET:/api/transaction-emails/{id}
     * @secure
     */
    getTransactionEmailById: (id: string, params: RequestParams = {}) =>
      this.request<TransactionEmailModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmails
     * @name GetTransactionEmailBatch
     * @request POST:/api/transaction-emails/{pageIndex},{pageSize}
     * @secure
     */
    getTransactionEmailBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TransactionEmailModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasureConversions
     * @name GetUnitOfMeasureConversionById
     * @request GET:/api/unit-of-measure-conversions/{id}
     * @secure
     */
    getUnitOfMeasureConversionById: (id: string, params: RequestParams = {}) =>
      this.request<UnitOfMeasureConversionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measure-conversions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasureConversions
     * @name AggregationUnitOfMeasureConversion
     * @request POST:/api/unit-of-measure-conversions/aggregation
     * @secure
     */
    aggregationUnitOfMeasureConversion: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measure-conversions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasureConversions
     * @name GetUnitOfMeasureConversionBatch
     * @request POST:/api/unit-of-measure-conversions/{pageIndex},{pageSize}
     * @secure
     */
    getUnitOfMeasureConversionBatch: (
      pageIndex: number,
      pageSize: number,
      data: QueryModel,
      params: RequestParams = {},
    ) =>
      this.request<UnitOfMeasureConversionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measure-conversions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasures
     * @name GetUnitOfMeasureById
     * @request GET:/api/unit-of-measures/{id}
     * @secure
     */
    getUnitOfMeasureById: (id: string, params: RequestParams = {}) =>
      this.request<UnitOfMeasureModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measures/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasures
     * @name AggregationUnitOfMeasure
     * @request POST:/api/unit-of-measures/aggregation
     * @secure
     */
    aggregationUnitOfMeasure: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measures/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnitOfMeasures
     * @name GetUnitOfMeasureBatch
     * @request POST:/api/unit-of-measures/{pageIndex},{pageSize}
     * @secure
     */
    getUnitOfMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<UnitOfMeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/unit-of-measures/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name DeleteVisitRules
     * @request DELETE:/api/visit-rules
     * @secure
     */
    deleteVisitRules: (data: QueryModel, params: RequestParams = {}) =>
      this.request<VisitRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name InsertVisitRule
     * @request POST:/api/visit-rules
     * @secure
     */
    insertVisitRule: (data: VisitRuleModel, params: RequestParams = {}) =>
      this.request<VisitRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name GetVisitRuleById
     * @request GET:/api/visit-rules/{id}
     * @secure
     */
    getVisitRuleById: (id: string, params: RequestParams = {}) =>
      this.request<VisitRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name PatchVisitRule
     * @request PATCH:/api/visit-rules/{id}
     * @secure
     */
    patchVisitRule: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<VisitRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name UpdateVisitRule
     * @request PUT:/api/visit-rules/{id}
     * @secure
     */
    updateVisitRule: (id: string, data: VisitRuleModel, params: RequestParams = {}) =>
      this.request<VisitRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name AggregationVisitRule
     * @request POST:/api/visit-rules/aggregation
     * @secure
     */
    aggregationVisitRule: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name GetVisitRuleGroupped
     * @request POST:/api/visit-rules/groupped
     * @secure
     */
    getVisitRuleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name GetVisitRuleBatch
     * @request POST:/api/visit-rules/{pageIndex},{pageSize}
     * @secure
     */
    getVisitRuleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<VisitRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VisitRules
     * @name ExportVisitRuleBatch
     * @request POST:/api/visit-rules/{pageIndex},{pageSize}/export
     * @secure
     */
    exportVisitRuleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/visit-rules/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name DeleteWorkTaskEvaluationGroups
     * @request DELETE:/api/work-task-evaluation-groups
     * @secure
     */
    deleteWorkTaskEvaluationGroups: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name InsertWorkTaskEvaluationGroup
     * @request POST:/api/work-task-evaluation-groups
     * @secure
     */
    insertWorkTaskEvaluationGroup: (data: WorkTaskEvaluationGroupModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name GetWorkTaskEvaluationGroupById
     * @request GET:/api/work-task-evaluation-groups/{id}
     * @secure
     */
    getWorkTaskEvaluationGroupById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name PatchWorkTaskEvaluationGroup
     * @request PATCH:/api/work-task-evaluation-groups/{id}
     * @secure
     */
    patchWorkTaskEvaluationGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name UpdateWorkTaskEvaluationGroup
     * @request PUT:/api/work-task-evaluation-groups/{id}
     * @secure
     */
    updateWorkTaskEvaluationGroup: (id: string, data: WorkTaskEvaluationGroupModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name PrintWorkTaskEvaluationGroupById
     * @request GET:/api/work-task-evaluation-groups/{id}/print
     * @secure
     */
    printWorkTaskEvaluationGroupById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name AggregationWorkTaskEvaluationGroup
     * @request POST:/api/work-task-evaluation-groups/aggregation
     * @secure
     */
    aggregationWorkTaskEvaluationGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name GetWorkTaskEvaluationGroupGroupped
     * @request POST:/api/work-task-evaluation-groups/groupped
     * @secure
     */
    getWorkTaskEvaluationGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name GetWorkTaskEvaluationGroupBatch
     * @request POST:/api/work-task-evaluation-groups/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskEvaluationGroupBatch: (
      pageIndex: number,
      pageSize: number,
      data: QueryModel,
      params: RequestParams = {},
    ) =>
      this.request<WorkTaskEvaluationGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluationGroups
     * @name ExportWorkTaskEvaluationGroupBatch
     * @request POST:/api/work-task-evaluation-groups/{pageIndex},{pageSize}/export
     * @secure
     */
    exportWorkTaskEvaluationGroupBatch: (
      pageIndex: number,
      pageSize: number,
      data: ExportQueryModel,
      params: RequestParams = {},
    ) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluation-groups/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name DeleteWorkTaskEvaluations
     * @request DELETE:/api/work-task-evaluations
     * @secure
     */
    deleteWorkTaskEvaluations: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name InsertWorkTaskEvaluation
     * @request POST:/api/work-task-evaluations
     * @secure
     */
    insertWorkTaskEvaluation: (data: WorkTaskEvaluationModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name GetWorkTaskEvaluationById
     * @request GET:/api/work-task-evaluations/{id}
     * @secure
     */
    getWorkTaskEvaluationById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name PatchWorkTaskEvaluation
     * @request PATCH:/api/work-task-evaluations/{id}
     * @secure
     */
    patchWorkTaskEvaluation: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name UpdateWorkTaskEvaluation
     * @request PUT:/api/work-task-evaluations/{id}
     * @secure
     */
    updateWorkTaskEvaluation: (id: string, data: WorkTaskEvaluationModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name AggregationWorkTaskEvaluation
     * @request POST:/api/work-task-evaluations/aggregation
     * @secure
     */
    aggregationWorkTaskEvaluation: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name GetWorkTaskEvaluationGroupped
     * @request POST:/api/work-task-evaluations/groupped
     * @secure
     */
    getWorkTaskEvaluationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskEvaluations
     * @name GetWorkTaskEvaluationBatch
     * @request POST:/api/work-task-evaluations/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskEvaluationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskEvaluationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-evaluations/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskGroups
     * @name GetWorkTaskGroupById
     * @request GET:/api/work-task-groups/{id}
     * @secure
     */
    getWorkTaskGroupById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskGroups
     * @name UpdateWorkTaskGroup
     * @request PUT:/api/work-task-groups/{id}
     * @secure
     */
    updateWorkTaskGroup: (id: string, data: WorkTaskGroupModel, params: RequestParams = {}) =>
      this.request<WorkTaskGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskGroups
     * @name AggregationWorkTaskGroup
     * @request POST:/api/work-task-groups/aggregation
     * @secure
     */
    aggregationWorkTaskGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskGroups
     * @name GetWorkTaskGroupBatch
     * @request POST:/api/work-task-groups/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name DeleteWorkTaskPlanItems
     * @request DELETE:/api/work-task-plan-items
     * @secure
     */
    deleteWorkTaskPlanItems: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name InsertWorkTaskPlanItem
     * @request POST:/api/work-task-plan-items
     * @secure
     */
    insertWorkTaskPlanItem: (data: WorkTaskPlanItemModel, params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name GetWorkTaskPlanItemById
     * @request GET:/api/work-task-plan-items/{id}
     * @secure
     */
    getWorkTaskPlanItemById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name PatchWorkTaskPlanItem
     * @request PATCH:/api/work-task-plan-items/{id}
     * @secure
     */
    patchWorkTaskPlanItem: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name UpdateWorkTaskPlanItem
     * @request PUT:/api/work-task-plan-items/{id}
     * @secure
     */
    updateWorkTaskPlanItem: (id: string, data: WorkTaskPlanItemModel, params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name AggregationWorkTaskPlanItem
     * @request POST:/api/work-task-plan-items/aggregation
     * @secure
     */
    aggregationWorkTaskPlanItem: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskPlanItems
     * @name GetWorkTaskPlanItemBatch
     * @request POST:/api/work-task-plan-items/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskPlanItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskPlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-plan-items/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name DeleteWorkTaskRules
     * @request DELETE:/api/work-task-rules
     * @secure
     */
    deleteWorkTaskRules: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name InsertWorkTaskRule
     * @request POST:/api/work-task-rules
     * @secure
     */
    insertWorkTaskRule: (data: WorkTaskRuleModel, params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name GetWorkTaskRuleById
     * @request GET:/api/work-task-rules/{id}
     * @secure
     */
    getWorkTaskRuleById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name PatchWorkTaskRule
     * @request PATCH:/api/work-task-rules/{id}
     * @secure
     */
    patchWorkTaskRule: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name UpdateWorkTaskRule
     * @request PUT:/api/work-task-rules/{id}
     * @secure
     */
    updateWorkTaskRule: (id: string, data: WorkTaskRuleModel, params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name PrintWorkTaskRuleById
     * @request GET:/api/work-task-rules/{id}/print
     * @secure
     */
    printWorkTaskRuleById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name AggregationWorkTaskRule
     * @request POST:/api/work-task-rules/aggregation
     * @secure
     */
    aggregationWorkTaskRule: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name GetWorkTaskRuleGroupped
     * @request POST:/api/work-task-rules/groupped
     * @secure
     */
    getWorkTaskRuleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name GetWorkTaskRuleBatch
     * @request POST:/api/work-task-rules/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskRuleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskRules
     * @name ExportWorkTaskRuleBatch
     * @request POST:/api/work-task-rules/{pageIndex},{pageSize}/export
     * @secure
     */
    exportWorkTaskRuleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-rules/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name DeleteWorkTasks
     * @request DELETE:/api/work-tasks
     * @secure
     */
    deleteWorkTasks: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name InsertWorkTask
     * @request POST:/api/work-tasks
     * @secure
     */
    insertWorkTask: (data: WorkTaskModel, params: RequestParams = {}) =>
      this.request<WorkTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name GetWorkTaskById
     * @request GET:/api/work-tasks/{id}
     * @secure
     */
    getWorkTaskById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name PatchWorkTask
     * @request PATCH:/api/work-tasks/{id}
     * @secure
     */
    patchWorkTask: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name UpdateWorkTask
     * @request PUT:/api/work-tasks/{id}
     * @secure
     */
    updateWorkTask: (id: string, data: WorkTaskModel, params: RequestParams = {}) =>
      this.request<WorkTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name AggregationWorkTask
     * @request POST:/api/work-tasks/aggregation
     * @secure
     */
    aggregationWorkTask: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name GetWorkTaskGroupped
     * @request POST:/api/work-tasks/groupped
     * @secure
     */
    getWorkTaskGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name GetWorkTaskBatch
     * @request POST:/api/work-tasks/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTasks
     * @name ExportWorkTaskBatch
     * @request POST:/api/work-tasks/{pageIndex},{pageSize}/export
     * @secure
     */
    exportWorkTaskBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-tasks/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name DeleteWorkTaskStatements
     * @request DELETE:/api/work-task-statements
     * @secure
     */
    deleteWorkTaskStatements: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name InsertWorkTaskStatement
     * @request POST:/api/work-task-statements
     * @secure
     */
    insertWorkTaskStatement: (data: WorkTaskStatementModel, params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name GetWorkTaskStatementById
     * @request GET:/api/work-task-statements/{id}
     * @secure
     */
    getWorkTaskStatementById: (id: string, params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name PatchWorkTaskStatement
     * @request PATCH:/api/work-task-statements/{id}
     * @secure
     */
    patchWorkTaskStatement: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name UpdateWorkTaskStatement
     * @request PUT:/api/work-task-statements/{id}
     * @secure
     */
    updateWorkTaskStatement: (id: string, data: WorkTaskStatementModel, params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name AggregationWorkTaskStatement
     * @request POST:/api/work-task-statements/aggregation
     * @secure
     */
    aggregationWorkTaskStatement: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name GetWorkTaskStatementGroupped
     * @request POST:/api/work-task-statements/groupped
     * @secure
     */
    getWorkTaskStatementGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name GetWorkTaskStatementBatch
     * @request POST:/api/work-task-statements/{pageIndex},{pageSize}
     * @secure
     */
    getWorkTaskStatementBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkTaskStatementModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkTaskStatements
     * @name ExportWorkTaskStatementBatch
     * @request POST:/api/work-task-statements/{pageIndex},{pageSize}/export
     * @secure
     */
    exportWorkTaskStatementBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/work-task-statements/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
